import {ON_HANDOVERS_LIST,ON_HANDOVERS_ADD,ON_HANDOVERS_UPDATE} from '../constants/ActionTypes';

const INIT_STATE = {
    handoversList: []
};


export default (state=INIT_STATE,action) => {
    switch (action.type){

        case ON_HANDOVERS_LIST: {
            return {...state, handoversList: action.payload};
        }
        case ON_HANDOVERS_ADD: {
            return {...state, handoversList: action.payload};
        }
        default:
            return state;
    }
}